<template>
    <div class="history-order">
        <div class="container p-0">
            <a href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
                Повернутися
            </a>
            <div :class="['history-order__wrapp',{'disabled':documentDisabled}]">
                <div class="history-order__item">
                    <div class="history-order__head">
                        Страховий продукт
                    </div>
                    <div class="history-order__form-group">
                        <div class="row">
                            <div class="col-md-4">
                                <label>Компанія</label>
                                <input type="text" class="form-control" v-model="order.companyInfo.name" disabled>
                            </div>
                            <div class="col-md-4">
                                <label>Франшиза, грн</label>
                                <input type="text" class="form-control" v-model="order.offer.franchise" disabled>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="history-order__item">
                    <div class="history-order__head">
                        Розрахунок
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Дата дії договору:</div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Початок</label>
                                <input v-if="skeletonOff" disabled v-model="order.contract.startedAt"
                                       class="form-control date-selector">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Закінчення</label>
                                <input v-if="skeletonOff" disabled v-model="order.contract.finishedAt"
                                       class="form-control date-selector">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Розрахунковий період</label>
                                <input v-if="skeletonOff" type="text" class="form-control" v-model="orderPeriod"
                                       disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Тип ТЗ (категорія):</div>
                        <div class="row">
                            <div class="col-md-4">
                                <input v-if="skeletonOff" :disabled="documentDisabled" :value="showAutoCategory()"
                                       class="form-control">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Місце реєстрації власника ТЗ:</div>
                        <div class="row">
                            <div class="col-md-4 form-group">
                                <input v-if="skeletonOff" :disabled="documentDisabled" :value="showCityRegister()"
                                       class="form-control">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                          </div>
                          <div class="row">
                              <div class="history-order__notification col-md-8">
                                  <div class="history-order__notification__wrapp">
                                      <div class="history-order__notification__icon">
                                        <svg width="30" height="30" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g id="Warning / Triangle_Warning">
                                            <path id="Vector" d="M12 9.00006V13.0001M4.37891 15.1999C3.46947 16.775 3.01489 17.5629 3.08281 18.2092C3.14206 18.7729 3.43792 19.2851 3.89648 19.6182C4.42204 20.0001 5.3309 20.0001 7.14853 20.0001H16.8515C18.6691 20.0001 19.5778 20.0001 20.1034 19.6182C20.5619 19.2851 20.8579 18.7729 20.9172 18.2092C20.9851 17.5629 20.5307 16.775 19.6212 15.1999L14.7715 6.79986C13.8621 5.22468 13.4071 4.43722 12.8135 4.17291C12.2957 3.94236 11.704 3.94236 11.1862 4.17291C10.5928 4.43711 10.1381 5.22458 9.22946 6.79845L4.37891 15.1999ZM12.0508 16.0001V16.1001L11.9502 16.1003V16.0001H12.0508Z" stroke="#FB923C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                          </g>
                                        </svg>
<!--                                          <b>Важливо</b>-->
                                      </div>
                                      <p>Місце реєстрації (проживання) власника транспортного засобу (фізичної особи) або
                                          місцезнаходження юридичної особи відповідно до документа про реєстрацію
                                          транспортного засобу</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-order__item history-order__client">
                    <div class="history-order__head">
                        Дані страхувальника
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Ідентифікація:</div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>{{ isLegalType() ? 'ЄДРПОУ' : 'ІПН' }}</label>
                                <input v-if="skeletonOff" type="text" class="form-control"
                                       v-model="order.insurant.documentation.uin" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div v-if="! isLegalType()" class="col-md-4">
                                <label>Дата народження</label>
                                <input v-if="skeletonOff" v-model="order.insurant.dateBirthAt"
                                       class="form-control date-selector" placeholder="" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                        <div class="row">
                            <div v-if="! isLegalType()" class="col-md-4">
                                <label>Прізвище</label>
                                <input v-if="skeletonOff" type="text" placeholder="" class="form-control"
                                       v-model="order.insurant.surname" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>{{ isLegalType() ? 'Назва' : 'Ім\'я' }}</label>
                                <input v-if="skeletonOff" type="text" placeholder="" class="form-control"
                                       v-model="order.insurant.name" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div v-if="! isLegalType()" class="col-md-4">
                                <label>По батькові</label>
                                <input v-if="skeletonOff" type="text" placeholder="" class="form-control"
                                       v-model="order.insurant.patronymic" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div v-if="! isLegalType()" class="col-md-4">
                                <label>Прізвище (Кирилицею)</label>
                                <input v-if="skeletonOff" type="text" placeholder="" class="form-control"
                                       v-model="order.insurant.surname_ua" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div  class="col-md-4"><!-- v-if="isLegalType" -->
                                <label>{{ isLegalType() ? 'Назва' : 'Ім\'я' }} (Кирилицею)</label>
                                <input v-if="skeletonOff" type="text" placeholder="" class="form-control"
                                       v-model="order.insurant.name_ua" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div v-if="! isLegalType()" class="col-md-4">
                                <label>По батькові (Кирилицею)</label>
                                <input v-if="skeletonOff" type="text" placeholder="" class="form-control"
                                       v-model="order.insurant.patronymic_ua" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Контактна інформація:</div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Телефон</label>
                                <input v-if="skeletonOff" type="text" placeholder="Телефон" class="form-control"
                                       v-model="order.insurant.phone" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Email</label>
                                <input v-if="skeletonOff" type="text" placeholder="Email" class="form-control"
                                       v-model="order.insurant.email" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Місто</label>
                                <input v-if="skeletonOff" type="text" placeholder="Місто" class="form-control"
                                       v-model="order.insurant.city" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div v-if="!isLegalType()" class="col-md-4">
                              <label>Адреса</label>
                              <input v-if="skeletonOff" type="text" placeholder="Адреса" class="form-control"
                                     v-model="order.insurant.address" :disabled="documentDisabled">
                              <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                        <div v-if="isLegalType()" class="row">
                            <div class="col-md-4">
                                <label>Адреса</label>
                                <input v-if="skeletonOff" type="text" placeholder="Адреса" class="form-control"
                                       v-model="order.insurant.address" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Контактна особа</label>
                                <input v-if="skeletonOff" type="text" placeholder="Контактна особа" class="form-control"
                                       v-model="order.insurant.contact.fullName" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Посада</label>
                                <input v-if="skeletonOff" type="text" placeholder="Посада" class="form-control"
                                       v-model="order.insurant.contact.position" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Тип документа, на підставі якого особа має повноваження</label>
                                <input v-if="skeletonOff" type="text"
                                       placeholder="Тип документа, на підставі якого особа має повноваження"
                                       class="form-control" v-model="order.insurant.contact.documentType"
                                       :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Номер документа, на підставі якого особа має повноваження</label>
                                <input v-if="skeletonOff" type="text"
                                       placeholder="Номер документа, на підставі якого особа має повноваження"
                                       class="form-control" v-model="order.insurant.contact.documentNumber"
                                       :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Дата документа, на підставі якого особа має повноваження</label>
                                <input v-if="skeletonOff" type="text"
                                       placeholder="Дата документа, на підставі якого особа має повноваження"
                                       class="form-control" v-model="order.insurant.contact.documentDate"
                                       :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isLegalType()" class="history-order__form-group">
                        <div class="row">
                            <div class="col-md-4">
                                <label>Документ, що засвідчує особу:</label>
                                <input v-if="skeletonOff" type="text" class="form-control" :value="showTypeDocument()"
                                       :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Орган, що видав</label>
                                <input v-if="skeletonOff" type="text" class="form-control"
                                       v-model="order.insurant.documentation.issuedBy" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Запис №</label>
                                <input v-if="skeletonOff" type="text" placeholder="Запись №" class="form-control"
                                       v-model="order.insurant.documentation.serial" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div v-if="!this.isDocumentERetiree(order.insurant.privilegeTypeId)" class="col-md-4">
                                <label>Документ №</label>
                                <input v-if="skeletonOff" type="text" placeholder="Документ №" class="form-control"
                                       v-model="order.insurant.documentation.number" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>{{
                                        !this.isDocumentERetiree(order.insurant.privilegeTypeId) ? 'Дата выдачі' : 'Закінчення дії'
                                    }}</label>
                                <input v-if="skeletonOff" v-model="order.insurant.documentation.dateOfIssue"
                                       class="form-control date-selector" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>

                        </div>
                    </div>
                    <!--                    <div v-else class="history-order__form-group">-->
                    <!--                        <div class="row">-->
                    <!--                            <div class="col-md-8">-->
                    <!--                                <label>Документ, що засвідчує особу:</label>-->
                    <!--                                <input v-if="skeletonOff" type="text" class="form-control" :value="showTypeDocument()" :disabled="documentDisabled">-->
                    <!--                                <PuSkeleton v-else class="skeleton-input"/>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                        <div class="row">-->
                    <!--                            <div class="col-md-4">-->
                    <!--                                <label>Запис №</label>-->
                    <!--                                <input v-if="skeletonOff" type="text" placeholder="Запись №" class="form-control" v-model="order.insurant.documentation.serial" :disabled="documentDisabled">-->
                    <!--                                <PuSkeleton v-else class="skeleton-input"/>-->
                    <!--                            </div>-->
                    <!--                            <div v-if="!this.isDocumentERetiree(order.insurant.privilegeTypeId)" class="col-md-4">-->
                    <!--                                <label>Документ №</label>-->
                    <!--                                <input v-if="skeletonOff" type="text" placeholder="Документ №" class="form-control" v-model="order.insurant.documentation.number" :disabled="documentDisabled">-->
                    <!--                                <PuSkeleton v-else class="skeleton-input"/>-->
                    <!--                            </div>-->
                    <!--                            <div class="col-md-4">-->
                    <!--                                <label>{{ !this.isDocumentERetiree(order.insurant.privilegeTypeId) ? 'Дата выдачі' : 'Закінчення дії' }}</label>-->
                    <!--                                <input v-if="skeletonOff" v-model="order.insurant.documentation.dateOfIssue" class="form-control date-selector" :disabled="documentDisabled">-->
                    <!--                                <PuSkeleton v-else class="skeleton-input"/>-->
                    <!--                            </div>-->
                    <!--                            <div class="col-md-8">-->
                    <!--                                <label>Орган, що видав</label>-->
                    <!--                                <input v-if="skeletonOff" type="text" class="form-control" v-model="order.insurant.documentation.issuedBy" :disabled="documentDisabled">-->
                    <!--                                <PuSkeleton v-else class="skeleton-input"/>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </div>
                <div class="history-order__item">
                    <div class="history-order__head">
                        Дані автомобіля
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Ідентифікація:</div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Держ. номер</label>
                                <input v-if="skeletonOff" type="text" placeholder="Держ. номер" class="form-control"
                                       v-model="order.insuranceObject.number" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Номер кузова (VIN-код)</label>
                                <input v-if="skeletonOff" type="text" placeholder="Номер кузова (VIN-код)"
                                       class="form-control" v-model="order.insuranceObject.vin" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Автомобіль:</div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Модель</label>
                                <input v-if="skeletonOff" type="text" class="form-control"
                                       v-model="order.insuranceObject.brand" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Марка</label>
                                <input v-if="skeletonOff" type="text" class="form-control"
                                       v-model="order.insuranceObject.model" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Рік випуску авто</label>
                                <input v-if="skeletonOff" type="text" class="form-control"
                                       v-model="order.insuranceObject.year" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label>Повна маса, кг</label>
                                <input v-if="skeletonOff" type="text" class="form-control"
                                       v-model="order.insuranceObject.additionalParameters.totalWeight" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-3">
                                <label>Маса без навантаження</label>
                                <input v-if="skeletonOff" type="text" class="form-control"
                                       v-model="order.insuranceObject.additionalParameters.ownWeight" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-3">
                                <label>Обʼєм двигуна ТЗ в см³*</label>
                                <input v-if="skeletonOff" type="text" class="form-control"
                                       v-model="order.insuranceObject.additionalParameters.capacity" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-3">
                                <label>К-ть місць для сидіння, з водієм</label>
                                <input v-if="skeletonOff" type="text" class="form-control"
                                       v-model="order.insuranceObject.additionalParameters.numberOfSeats" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-order__item">
                    <div class="history-order__head">
                        Інше
                    </div>
                    <div class="history-order__form-group">
                        <div class="row">
                            <div class="col-md-6">
                                <label>Примітки:</label>
                                <textarea v-if="skeletonOff" class="form-control" disabled></textarea>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                    <div class="history-order__form-group border-none m-b-none">
                        <div class="row">
                            <div class="col-md-8">
                                <label>Створити на підставі даного договору новий договір:</label>
                                <select v-if="skeletonOff" class="form-control" disabled>
                                    <option value="1">Зелена картка</option>
                                </select>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-order__price">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="history-order__price__item">
                                <p>Платіж:</p>
                                <b> {{ showPrice() }} <span>грн</span></b>
                            </div>
                            <div v-if="showDiscountPrice()" class="history-order__price__item">
                                <p>З урахуванням знижки:</p>
                                <b> {{ showDiscountPrice() }} <span>грн</span></b>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-order__nav">
                    <div class="row">

                    </div>
                </div>

                <div v-if="this.loadData" class="partner-order__nav">
                    <div class="row">
                        <div class="col-md-8" v-if="order.edit">
                            <div class="row">
                                <div v-if="order.statusId == 1 && user && user.recipientTypeId !== 4" class="col-md-6">
                                    <button type="button" @click="declare(order)" class="btn-blue-w">Редагувати і
                                        заявити
                                    </button>
                                </div>
                                <div v-if="order.statusId == 5 && user && user.recipientTypeId !== 4" class="col-md-6">
                                    <button :disabled="isСoncludeProcess" type="button"
                                            @click="declare(order,false,false,2)" class="btn-blue-w">
                                        <span v-if="isСoncludeProcess" class="spinner-border spinner-border-sm"
                                              role="status" aria-hidden="true"></span>
                                        <span v-else>Продовжити</span>
                                    </button>
                                </div>
                                <div class="col-md-6">
                                    <button type="button" @click="draft()" class="btn btn-dark">Переглянути чернетку
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="!hideCopyForApi">
                            <button :disabled="isCopyProcess" type="button" @click="copy(order)"
                                    class="btn btn-success">
                                <span v-if="isCopyProcess" class="spinner-border spinner-border-sm" role="status"
                                      aria-hidden="true"></span>
                                <span v-else>Копіювати</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import { calculate } from '../../api/offer';

import { concludeOrder, showOrder } from '../../api/order';
import { customerMixin, HistoryMixin } from '../../mixin';
import { contractGreenCard } from '@/api/contractGreenCard';
import { list as calculateGreenCard } from '@/api/greenCardInsuranceCompany';
const FileDownload = require('js-file-download');

export default {
  components: { Multiselect, contractGreenCard },
  mixins: [customerMixin, HistoryMixin],
  data: function () {
    return {
      loadMoreOptions: {},
      loadData: false,
      skeletonOff: false,
      isCopyProcess: false,
      isСoncludeProcess: false,
      togglerVisible: true,
      documentDisabled: true,
      orderPeriod: '1 рік',
      periodOptions: [
        { 'id': 15, 'count': '15', 'key': 'd', 'name': '15 д' },
        { 'id': 1, 'count': '1', 'key': 'm', 'name': '1 міс' },
        { 'id': 2, 'count': '2', 'key': 'm', 'name': '2 міс' },
        { 'id': 3, 'count': '3', 'key': 'm', 'name': '3 міс' },
        { 'id': 4, 'count': '4', 'key': 'm', 'name': '4 міс' },
        { 'id': 5, 'count': '5', 'key': 'm', 'name': '5 міс' },
        { 'id': 6, 'count': '6', 'key': 'm', 'name': '6 міс' },
        { 'id': 7, 'count': '7', 'key': 'm', 'name': '7 міс' },
        { 'id': 8, 'count': '8', 'key': 'm', 'name': '8 міс' },
        { 'id': 9, 'count': '9', 'key': 'm', 'name': '9 міс' },
        { 'id': 10, 'count': '10', 'key': 'm', 'name': '10 міс' },
        { 'id': 11, 'count': '11', 'key': 'm', 'name': '11 міс' },
        { 'id': 12, 'count': '12', 'key': 'm', 'name': '12 міс' },
      ],
      order: {
        offer: {},
        contract: {},
        companyInfo: {},
        insuranceObject: {},
        insurant: {
          documentation: {},
        }
      }
    };
  },
  computed: {
    // isLegalType() {
    //     //вынести это в миксин
    //     return this.order.insurant.customerTypeId === 2;
    // },
    user() {
      return this.$store.getters.USER;
    },
    orderTypes: function () {
      return this.$store.getters.ORDER_TYPES;
    },
  },
  created() {
    showOrder(this.$route.params.orderId).then((response) => {
      this.order = response.data.data;
      this.loadData = true;
      this.skeletonOff = true;

      this.getContractPeriod();
    });
  },
  mounted() {
    this.getContractPeriod();
  },

  methods: {
    draft() {
      window.open(`/api/orders/draft/${this.$store.getters.USER.id}/${this.$route.params.orderId}`);
    },
    showPrice() {
      let price = parseFloat(this.order.price);

      if (isNaN(price)) {
        return 0;
      }

      return price.toFixed(2);
    },
    showDiscountPrice() {
      if (this.order.discountPrice) {
        let price = parseFloat(this.order.discountPrice);

        if (isNaN(price)) {
          return 0;
        }

        if (price) {
          return price.toFixed(2);
        }

        return 0;
      }

      return 0;
    },
    showTypeDocument() {
      if (this.order.insurant?.documentation?.type) {
        return this.$_.findWhere(this.$store.getters.DOCUMENTS_TYPES, { id: this.order.insurant.documentation.type })?.name;
      }
    },
    showAutoCategory() {
      if (this.order.insuranceObject.autoCategory) {
        return `(${this.order.insuranceObject.autoCategory})`;
      }
    },

    showCityRegister() {
      if (this.order.insurant.city) {
        return this.order.insurant.city;
      }
    },
    euroStatus(value) {
      $('[data-toggle="tooltip"]').tooltip('hide');
      if (this.euroChecked === true) {
        this.city = value;
        $('.city-select').addClass('disabled');
      } else {
        this.city = null;
        $('.city-select').removeClass('disabled');
      }
    },
    choseCity(value) {
      this.city = value;
      $('.tooltip').remove();
      this.euroChecked = false;
      $('.params-city-status').removeClass('disabled');
    },
    getContractPeriod() {
      let currentYear = parseInt(moment(this.order.contract.finishedAt, 'DD/MM/YYYY').format('YYYY'));
      let currentMonth = parseInt(moment(this.order.contract.finishedAt, 'DD/MM/YYYY').format('MM'));
      let currentDay = parseInt(moment(this.order.contract.finishedAt, 'DD/MM/YYYY').format('DD'));
      let startYear = parseInt(moment(this.order.contract.startedAt, 'DD/MM/YYYY').format('YYYY'));
      let startMonth = parseInt(moment(this.order.contract.startedAt, 'DD/MM/YYYY').format('MM'));
      let startDay = parseInt(moment(this.order.contract.startedAt, 'DD/MM/YYYY').format('DD'));

      let diffYears = moment(new Date((currentYear + 1), new Date(currentMonth - 1), new Date(currentDay - 1))).diff(new Date((startYear + 1), new Date(startMonth - 1), new Date(startDay - 1)), 'years', true);
      let diffMonths = moment(new Date((currentYear + 1), new Date(currentMonth - 1), new Date(currentDay - 1))).diff(new Date((startYear + 1), new Date(startMonth - 1), new Date(startDay - 1)), 'months', true);
      let diffDays = moment(new Date((currentYear + 1), new Date(currentMonth - 1), new Date(currentDay - 1))).diff(new Date((startYear + 1), new Date(startMonth - 1), new Date(startDay - 1)), 'days', true);

      if (diffYears >= 1) {
        let count = Math.round(diffYears);
        if (count >= 2) {
          this.orderPeriod = count + ' роки';
        } else if (count >= 5) {
          this.orderPeriod = count + ' років';
        } else {
          this.orderPeriod = count + ' рік';
        }
      } else if (diffDays > 15) {
        let count = Math.ceil(diffMonths);
        if (count < 5 && count > 1) {
          this.orderPeriod = count + ' місяці';
        } else if (count >= 5) {
          this.orderPeriod = count + ' місяців';
        } else {
          this.orderPeriod = count + ' місяць';
        }
      } else {
        let count = diffDays;
        if (count <= 15) {
          this.orderPeriod = '15 днів';
        } else {
          this.orderPeriod = count + ' днів';
        }
      }
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

